import { Stack } from "@mantine/core";
import { PageHeader } from "components";
import PageContent from "components/layouts/PageContent";
import { CommonParamsType } from "constants/types/common";
import { InventoryParamsType } from "constants/types/inventory";
import { FC, useCallback } from "react";
import { useTableParams } from "utils/hooks/common/useTableParams";
import InventoryActions from "./components/InventoryActions/InventoryActions";
import InventoryTable from "./components/InventoryTable/InventoryTable";

const INVENTORY_PAGE_TITLE = "Quản lý Tồn kho";

const InventoryWebLayout: FC = () => {
  const { params, setParams, handlePageChange, handleLimitChange, handleSearch } =
    useTableParams<InventoryParamsType>();

  const handleFiltersChange = useCallback(
    (filters: Partial<Omit<InventoryParamsType, keyof CommonParamsType>>) => {
      setParams((prev) => ({ ...prev, ...filters, page: 1 }));
    },
    [setParams],
  );

  return (
    <Stack gap="sm">
      <PageHeader breadcrumbs={[{ title: INVENTORY_PAGE_TITLE, href: "" }]} />
      <PageContent>
        <Stack gap="xs">
          <InventoryActions
            handleSearch={handleSearch}
            params={params}
            onFilterChange={handleFiltersChange}
          />
          <InventoryTable
            params={params}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
          />
        </Stack>
      </PageContent>
    </Stack>
  );
};

export default InventoryWebLayout;
